import React from "react";
import WhitelabelContext from "student-front-commons/src/components/WhitelabelContext";
import Image from "core/Image";
import Entity from "student-front-commons/src/components/Entity";

const Logo = (props) => (
  <WhitelabelContext.Consumer>
    {({ kidsLogoUrl }) => (
      <Entity name="profile">
        {({ getById: getProfileById }) => (
          <Entity name="company">
            {({ getById: getCompanyById }) => {
              const student = getProfileById(sessionStorage.getItem("id"));
              const company = getCompanyById(student.company);
              return (
                <Image
                  src={company.logoUrl ? `${process.env.REACT_APP_FILES_URL}/${company.logoUrl}` : kidsLogoUrl}
                  {...props}
                />
              );
            }}
          </Entity>
        )}
      </Entity>
    )}
  </WhitelabelContext.Consumer>
);

export default Logo;
